import { render, staticRenderFns } from "./MemberRefundBalance.vue?vue&type=template&id=0397bd00&scoped=true&"
import script from "./MemberRefundBalance.vue?vue&type=script&lang=js&"
export * from "./MemberRefundBalance.vue?vue&type=script&lang=js&"
import style0 from "./MemberRefundBalance.vue?vue&type=style&index=0&id=0397bd00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0397bd00",
  null
  
)

export default component.exports